/**
 * 定义公用常量
 */
define([], function () {
  /* eslint-disable key-spacing, comma-dangle */

  const BeautifyTemplatePageSource = {
    PAGESOURCE_INVALID            : 0,

    PAGE_MORE_TEMPLATE_PANEL      : 100,
    PAGE_MORE_TEMPLATE_ONLINELIST : 101, // 更多模板在线模板
    PAGE_MORE_TEMPLATE_PAID       : 102, // 更多模板已购界面
    PAGE_MORE_TEMPLATE_PREVIEW    : 103, // 更多模板预览界面
    PAGE_MORE_TEMPLATE_DETAILS    : 104, // 更多模板详情页

    PAGE_DESIGN_TEMPLATE_INLINE   : 200, // 设计模板展台

    PAGE_LAYOUT_PANEL             : 400, // 更改版式页面展示
    PAGE_LAYOUT_MATCH_ONLINE      : 401, // 推荐版式网页版
    PAGE_LAYOUT_LOCAL             : 402, // 本机版式网页版
    PAGE_LAYOUT_DETAILS           : 403, // 更改版式详情页

    PAGE_NEWSLIDE_PANEL           : 500, // 新建slide页面展示
    PAGE_NEWSLIDE_ONLINE          : 501, // 新建在线slide网页
    PAGE_NEWSLIDE_LOCAL           : 502, // 本机版式tab网页
    PAGE_NEWSLIDE_RECENT          : 503, // 最近使用tab网页
    PAGE_NEWSLIDE_PAID            : 504, // 已购页面
    PAGE_NEWSLIDE_DETAILS         : 505, // 新建slide详情页
  };

  const ResRoot = '/Resources/beautifydocument';

  const ResUrl = {
    URL_SLIDE_DETAILS    : `${ResRoot}/newslide/views/details.html`,
    URL_LAYOUT_DETAILS   : `${ResRoot}/changelayout/views/details.html`,
    URL_MORE_TEMPLATES   : `${ResRoot}/moretemplate/views/template.html`,
    URL_TEMPLATE_DETAILS : `${ResRoot}/moretemplate/views/details.html`,
    URL_PAYMENT          : `${ResRoot}/payment/views/payment.html`,
    URL_UNIPAY           : `${ResRoot}/unipay/views/payment.html`,
    URL_NEWFILE_PREVIEW  : `${ResRoot}/newfile/views/preview.html`
  };

  const Channel = {
    CHANNEL_TMPL_BUY_STATE_CHANGE: 'channelTmplBuyStateChange',
    CHANNEL_NEW_FILE_FINISHED : 'channelNewFileFinished',
    CHANNEL_TMPL_COLLECTED_STATE_CHANGE: 'channelTmplCollectedStateChange',
  }

  // 测试数据均在此处配置
  const TestEnv = {
    wpsSid: '3d59db75e218b65988205b4989ed82258opd544300034777d8' // 测试sid
  };

  return {
    BeautifyTemplatePageSource,
    ResUrl,
    Channel,
    TestEnv
  };
});



/** WEBPACK FOOTER **
 ** ./src/scripts/constants.js
 **/